"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuItemDDI = void 0;
var menuItemModule = require('./menu-item-ddi.module.scss');
var Bandeiras_1 = require("../../../../assets/flags/Bandeiras");
var react_1 = __importDefault(require("react"));
var MenuItemDDI = function (_a) {
    var _b = _a.item, item = _b === void 0 ? {} : _b, styleBandeira = _a.styleBandeira, estaSelecionado = _a.estaSelecionado, quebraDeLinha = _a.quebraDeLinha, esconderTextoExtenso = _a.esconderTextoExtenso, regraTexto = _a.regraTexto, onClick = _a.onClick;
    //#region Variaveis
    var selecionado = estaSelecionado ? menuItemModule.selecionado : '';
    var quebrarLinhas = quebraDeLinha ? menuItemModule.quebraDeLinha : '';
    var esconderTexto = esconderTextoExtenso ? menuItemModule.esconderTextoExtenso : '';
    var classesTextoInterno = "".concat(selecionado, " ").concat(quebrarLinhas, " ").concat(esconderTexto);
    //#region Render
    return (react_1.default.createElement("div", { onClick: function () { return onClick === null || onClick === void 0 ? void 0 : onClick(item); }, className: "".concat(menuItemModule.menuItem, " ").concat(selecionado) },
        react_1.default.createElement(Bandeiras_1.Bandeiras, { Altura: "25px", Largura: "25px", bandeira: item.bandeira, className: '', style: styleBandeira }),
        react_1.default.createElement("div", { className: classesTextoInterno }, regraTexto(item))));
};
exports.MenuItemDDI = MenuItemDDI;
